import { render, staticRenderFns } from "./DynamicHalfBanner.vue?vue&type=template&id=5715a86e&scoped=true&"
import script from "./DynamicHalfBanner.vue?vue&type=script&lang=ts&"
export * from "./DynamicHalfBanner.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicHalfBanner.vue?vue&type=style&index=0&id=5715a86e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715a86e",
  null
  
)

export default component.exports